import React, { useEffect, useState } from "react";
import { makeStyles } from '@mui/styles';
import { Button, IconButton } from '@mui/material';
import { ArrowBack } from "@mui/icons-material";
import jwt from 'jsonwebtoken';

import Sotyktu_Strip from "../shared/assets/pass_images/sotyktu_ios_pass_mobile.png";
import Zeposia_Strip from "../shared/assets/pass_images/zeposia_ios_pass_mobile.png";
import Camzyos_Strip from "../shared/assets/pass_images/camzyos_ios_pass_mobile.svg";

let userNames = [
    {
        fname: "James",
        lname: "Smith",
        rxbin: "123456",
        grp: "789012",
        rxpcn: "345678",
        id: "912345",
        email: "james.smith@bms.com",
        occupation: "Developer",
    },
    {
        fname: "John",
        lname: "Doe",
        rxbin: "610524",
        grp: "50776822",
        rxpcn: "LOYALTY",
        id: "123456",
        email: "john.doe@bms.com",
        occupation: "Analyst",
    },
    {
        fname: "Linda",
        lname: "Miller",
        rxbin: "123456",
        grp: "789012",
        rxpcn: "345678",
        id: "912345",
        email: "linda.miller@bms.com",
        occupation: "Tester",
    },
    {
        fname: "Maria",
        lname: "Jones",
        rxbin: "123456",
        grp: "789012",
        rxpcn: "345678",
        id: "912345",
        email: "maria.jones@bms.com",
        occupation: "Developer",
    },
    {
        fname: "Robert",
        lname: "Johnson",
        rxbin: "123456",
        grp: "789012",
        rxpcn: "345678",
        id: "912345",
        email: "robert.johnson@bms.com",
        occupation: "DB Manager",
    },
];

const useStyles = makeStyles({
    container: {
        display: "flex",
        justifyContent: "center",
        width: "100%"
    },
    content: {
        width: "100%",
        maxWidth: "600px",
        margin: "20px",
        padding: "20px",
        textAlign: 'start',
        backgroundColor: "#fff",
        borderRadius: "4px",
        boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)"
    },
    textInput: {
        width: "100%",
        fontSize: '16px',
        padding: "8px",
        outline: "none",
        border: "1px solid #6b7280",
        borderRadius: "5px"
    },
    selectRoot: {
        width: "100%",
    },
    selectInput: {
        width: "100%",
        fontSize: "16px",
        padding: "8px",
        borderRadius: "5px",
        outline: "none"
    },
    cidSelect: {
        fontSize: '16px',
        padding: "8px",
        outline: "none",
        border: "1px solid #6b7280",
        borderRadius: "5px"
    },
    inputLabel: {
        marginBottom: "2px"
    },
    required: {
        color: 'red'
    },
    stripImg: {
        display: "flex",
        justifyContent: "center",
        marginBottom: "20px"
    },
    imgRoot: {
        maxWidth: '350px',
        width: '85%',
        borderRadius: '8px',
        boxShadow: '0 3px 10px rgb(0 0 0 / 20%)'
    }
});

const Generate = (props) => {
    const classes = useStyles();

    const [navigateView, setNavigateView] = useState(false);

    const [productName, setProductName] = useState('Sotyktu');
    const [memberID, setMemberID] = useState('');
    const [cid, setCid] = useState('');
    const [customerID, setCustomerID] = useState('');
    const [tc, setTc] = useState('');
    const [cidLabel, setCidLabel] = useState('e_');

    const [copyBtnLabel, setCopyBtnLabel] = useState('Copy to clipboard');

    const downloadLink = React.useRef();

    const goToLocal = () => {
        const pass_data = {
            product: productName,
            member_id: memberID,
            cid,
            customerID,
            tc
        }
        const token = jwt.sign(pass_data, '9y$B&E)H@McQfTjWnZr4t7w!z%C*F-Ja');
        const URL = `http://localhost:3000/?data=${token}`
        window.open(URL, '_blank');
    }

    const goToCopayDEV = (option) => {
        if (option === 'opt1') {
            const pass_data = {
                product: productName,
                member_id: memberID,
                cid,
                customerID,
                tc
            }
            const token = jwt.sign(pass_data, '9y$B&E)H@McQfTjWnZr4t7w!z%C*F-Ja');
            const URL = `https://walletcopay-dev.web-dev.bms.com/?data=${token}`
            window.open(URL, '_blank');
        }
    }

    // const goToCopayUAT = (option) => {
    //     if (option === 'opt1') {
    //         const pass_data = {
    //             product: productName,
    //             member_id: memberID,
    //             cid,
    //             customerID,
    //             tc
    //         }
    //         const token = jwt.sign(pass_data, '9y$B&E)H@McQfTjWnZr4t7w!z%C*F-Ja');
    //         const URL = `https://walletcopay-uat.web-dev.bms.com/?data=${token}`
    //         window.open(URL, '_blank');
    //     }
    // }

    const goToCopayPROD = (option) => {
        if (option === 'opt1') {
            const pass_data = {
                product: productName,
                member_id: memberID,
                cid,
                customerID,
                tc
            }
            const token = jwt.sign(pass_data, 'i,rE3iif7mKA,p,');
            const URL = `https://walletcopay.web.bms.com/?data=${token}`
            window.open(URL, '_blank');
        }
    }

    const copyURL = () => {
        const pass_data = {
            product: productName,
            member_id: memberID
        }
        const token = jwt.sign(pass_data, '9y$B&E)H@McQfTjWnZr4t7w!z%C*F-Ja');
        const URL = `https://walletcopay-dev.web-dev.bms.com/?data=${token}`;
        navigator.clipboard.writeText(URL);
        setCopyBtnLabel('URL copied!');
    }

    const fetchStringImage = () => {
        switch (productName) {
            case 'Sotyktu': return <img className={classes.imgRoot} src={Sotyktu_Strip} alt="card" />
            case 'Zeposia': return <img className={classes.imgRoot} src={Zeposia_Strip} alt="card" />
            case 'Camzyos': return <img className={classes.imgRoot} src={Camzyos_Strip} alt="card" />
            default: break;
        }
    }

    return (
        <div className={classes.container}>
            <div className={classes.content}>
                {!navigateView ?
                    <>
                        <h2 style={{ marginBottom: "10px" }}>Generate Pass</h2>
                        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                <p className={classes.inputLabel}>Product <span className={classes.required}>*</span></p>
                                <select value={productName} className={classes.selectInput} onChange={(e) => setProductName(e.target.value)}>
                                    <option value="Sotyktu">Sotyktu</option>
                                    <option value="Zeposia">Zeposia</option>
                                    <option value="Camzyos">Camzyos</option>
                                </select>
                            </div>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                <p className={classes.inputLabel}>Member ID <span className={classes.required}>*</span></p>
                                <input
                                    type="text"
                                    name="memberID"
                                    className={classes.textInput}
                                    maxLength={"50"}
                                    onChange={(e) => setMemberID(e.target.value)}
                                    value={memberID}
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", flexWrap: "wrap" }}>
                                <p className={classes.inputLabel}>CID <span className={classes.required}>*</span></p>
                                <div style={{ display: 'flex', gap: '5px' }}>
                                    <select value={cidLabel} className={classes.cidSelect} onChange={(e) => {
                                        setCidLabel(e.target.value);
                                    }}>
                                        <option value="e_">e_</option>
                                        <option value="sms_">sms_</option>
                                    </select>
                                    <input
                                        id="cid"
                                        type="text"
                                        name="cid"
                                        className={classes.textInput}
                                        maxLength={"50"}
                                        onChange={(e) => setCid(e.target.value)}
                                        value={cid}
                                        style={{
                                            display: 'block',
                                            overflow: 'hidden',
                                            minWidth: 'auto'
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                <p className={classes.inputLabel}>Customer ID <span className={classes.required}>*</span></p>
                                <input
                                    type="text"
                                    name="customerID"
                                    className={classes.textInput}
                                    maxLength={"50"}
                                    onChange={(e) => setCustomerID(e.target.value)}
                                    value={customerID}
                                />
                            </div>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                <p className={classes.inputLabel}>Tracking Code <span className={classes.required}>*</span></p>
                                <input
                                    type="text"
                                    name="tc"
                                    className={classes.textInput}
                                    maxLength={"50"}
                                    onChange={(e) => setTc(e.target.value)}
                                    value={tc}
                                />
                            </div>
                            <Button
                                disabled={!(productName.length > 0 && memberID.length > 0 && cid.length > 0 && customerID.length > 0 && tc.length > 0 && cidLabel.length > 0)}
                                variant={"contained"}
                                sx={{
                                    backgroundColor: "#BE2BBB",
                                    color: "#fff",
                                    padding: "0.5rem 2rem",
                                    '&:hover': {
                                        backgroundColor: "#6b7280 !important",
                                    }
                                }}
                                onClick={() => setNavigateView(true)}
                            >
                                Submit
                            </Button>
                        </div>
                    </>
                    :
                    <div style={{ display: "block" }} className="head-text">
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                            <IconButton onClick={() => { setNavigateView(false) }}>
                                <ArrowBack />
                            </IconButton>
                            <h2>Wallet Card</h2>
                        </div>
                        <br />
                        <div className={classes.stripImg}>
                            {fetchStringImage()}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexFlow: "wrap" }}>
                            {window.location.hostname === 'localhost' && <Button style={{
                                backgroundColor: "#BE2BBB",
                                color: "#fff",
                                textTransform: "none",
                            }}
                                color={"primary"}
                                variant={"contained"}
                                onClick={() => goToLocal()}
                            >
                                Go to Local
                            </Button>
                            }
                            <Button style={{
                                backgroundColor: "#BE2BBB",
                                color: "#fff",
                                textTransform: "none",
                            }}
                                color={"primary"}
                                variant={"contained"}
                                onClick={() => copyURL()}
                            >
                                {copyBtnLabel}
                            </Button>
                            <Button style={{
                                backgroundColor: "#BE2BBB",
                                color: "#fff",
                                textTransform: "none",
                            }}
                                color={"primary"}
                                variant={"contained"}
                                onClick={() => goToCopayDEV('opt1')}
                            >
                                Go to CoPay DEV
                            </Button>
                            <Button style={{
                                backgroundColor: "#BE2BBB",
                                color: "#fff",
                                textTransform: "none",
                            }}
                                color={"primary"}
                                variant={"contained"}
                                onClick={() => goToCopayPROD('opt1')}
                            >
                                Go to CoPay PROD
                            </Button>
                        </div>
                        <a ref={downloadLink} />
                        {/* <WalletBackdrop value={loading} /> */}
                    </div>
                }
            </div>
        </div >
    );
}

export default Generate;
